export default {"src":"/_next/static/media/mint.b46c7078.svg","height":116,"width":131};